"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hoseasonsDeposits = void 0;
const cottagesDeposits_1 = require("./cottagesDeposits");
const termsConditionsContent = `
## Low deposit for 2024 and 2025

### UK Parks and Lodges
1. The following terms and conditions apply to new 2023, 2024 & 2025 Hoseasons Lodges & Parks bookings in the UK, with arrival dates which are more than 10 weeks after you make your booking, and which are booked between 17 November 2023 and 31 December 2025.
2. These terms and conditions should be read with the Booking Conditions. Especially note clauses 6 (Payment), 7 (Deposit) and 10 (Full customer cancellations – basic) of the Booking Conditions.
3. Offer only available for accommodation that participates in the low deposit scheme.
4. We can decide to extend or withdraw this offer depending on popularity and park availability.
5. This offer may be used in conjunction with any other accommodation offer or discount that is available at the time of booking.

#### MAKING YOUR BOOKING
6. The low deposit under this offer for booking costs are as follows:
- up to £2,000 = £10
- +£2,001 – Not applicable

When you make your booking, in addition to the low deposit payable, you will also have to pay the Enhanced Cancellation Terms fee (if you choose to benefit from the Enhanced Cancellation Terms).
7. **The difference between the low deposit and the standard deposit shown on website and/or in the Booking Conditions is payable with the balance payment, which we must receive no later than:**

   a) **10 weeks prior to the start of your trip; or**

   b) **at the time of cancellation if you cancel your booking before the balance due date. **

#### BOOKING CANCELLATION
8. **This balance payment will include all applicable charges as detailed on your booking confirmation. If payment is not received in full on time, we can treat your booking as cancelled by you for a non-refundable reason. If this happens, you will be responsible for the difference between the low deposit and the usual deposit and any cancellation charges which may apply (as set out in the Booking Conditions) For the avoidance of doubt, you will forfeit the Enhanced Cancellation Terms fee (if applicable).**
9. If you have made your booking with the benefit of the Enhanced Cancellation Terms, and provided you cancel for a qualifying reason before the balance due date, all you will need to pay is the difference between the low deposit and the £60 administration charge.

## Standard deposit

1. For most bookings, we will ask you to pay a non-refundable deposit, to secure your booking.
2. The standard deposit is 20% of the accommodation rental price, but we may occasionally require you to pay more or less. You will be told what the deposit is prior to making the booking.
3. If you book an accommodation with a deposit which is lower than the standard deposit, you also agree to pay the difference between the amount paid and the standard deposit. You must make this additional payment either at the time the balance of your booking is due or, if you cancel before the balance due date, at the time you cancel the booking. Terms of any low deposit scheme, if available for your accommodation, will be displayed on our website. Please also refer to Annex A if you have purchased the Enhanced Cancellation Terms.
`;
const termsConditionsTitle = 'Terms & conditions';
exports.hoseasonsDeposits = [
    ...cottagesDeposits_1.cottagesDeposits.map((deposit) => ({
        ...deposit,
        termsConditionsTitle,
    })),
    {
        accommodationTypes: ['holiday-parks', 'lodges', 'accom'],
        amount: 10,
        unitType: 'price',
        termsConditionsContent,
        termsConditionsTitle,
        rules: {
            bookingStartDateMin: new Date('2021-12-17'),
            bookingStartDateMax: new Date('2050-12-31'),
            bookingLeadTimeMin: 70, // eqv. to 10 weeks
            bookingPriceMin: 0,
            bookingPriceMax: 2000,
            propertySleepsMin: 0,
            propertySleepsMax: Number.MAX_VALUE,
        },
    },
    {
        accommodationTypes: ['holiday-parks', 'lodges', 'accom'],
        amount: 20,
        unitType: 'percentage',
        termsConditionsContent,
        termsConditionsTitle,
        rules: {
            bookingStartDateMin: new Date('2021-12-17'),
            bookingStartDateMax: new Date('2050-12-31'),
            bookingLeadTimeMin: 70,
            bookingPriceMin: 2001,
            bookingPriceMax: Number.MAX_VALUE,
            propertySleepsMin: 0,
            propertySleepsMax: Number.MAX_VALUE,
        },
    },
];
//# sourceMappingURL=hoseasonsDeposits.js.map